<template>
  <h2 class="DhCardTitleComponent">
    <slot></slot>
  </h2>
</template>

<script>
  export default {
    name: 'DhCardTitle',
    components: {},
    props: {
      // https://vuejs.org/v2/guide/components.html#Prop-Validation
      // propname: String
    },
    computed: {},
    watch: {},
    mixins: [],
    data: function () {
      return {}
    },
    filters: {},
    methods: {},
    created: function () {
    },
    mounted: function () {
    },
    updated: function () {
    },
    destroyed: function () {
    }
  }
</script>

<style scoped>
  .DhCardTitleComponent {
    font-family: var(--font-display);
    font-size: var(--font-size-medium-heading);
    text-align: center;
    display: block;
    width: 100%;
  }
</style>
